import { y as e } from "../../chunks/icons-BQHDHs7w.js";
import { useEffect as t, useRef as n } from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { trackEvent as a } from "@cx-web/utils/dataLayer";
var o = {
	articleLoginWall: "_articleLoginWall_o4wyt_1",
	contentWrapper: "_contentWrapper_o4wyt_11",
	backgroundContainer: "_backgroundContainer_o4wyt_20",
	title: "_title_o4wyt_30",
	subtitle: "_subtitle_o4wyt_45",
	bulletsWrapper: "_bulletsWrapper_o4wyt_64",
	benefitBullet: "_benefitBullet_o4wyt_73",
	itemIcon: "_itemIcon_o4wyt_86",
	itemTextWrapper: "_itemTextWrapper_o4wyt_90",
	itemHeader: "_itemHeader_o4wyt_94",
	itemBody: "_itemBody_o4wyt_99",
	ctaWrapper: "_ctaWrapper_o4wyt_105",
	primaryCta: "_primaryCta_o4wyt_139",
	secondaryCta: "_secondaryCta_o4wyt_147"
}, s = ({ onLogin: t, onSignup: n, resourcesUrl: s }) => {
	let c = `${s}/assets/img/global/product-switcher-locked-background`;
	return /* @__PURE__ */ i("div", {
		className: o.articleLoginWall,
		children: [/* @__PURE__ */ i("picture", {
			className: o.backgroundContainer,
			children: [/* @__PURE__ */ r("source", {
				media: "(max-width: 1023px)",
				srcSet: `${c}-mobile.png`
			}), /* @__PURE__ */ r("img", {
				alt: "login-wall-background",
				"data-testid": "login-wall-background",
				src: `${c}-desktop.png`
			})]
		}), /* @__PURE__ */ i("div", {
			className: o.contentWrapper,
			children: [
				/* @__PURE__ */ r("h1", {
					className: o.title,
					children: "Join the oddschecker Roster for Free"
				}),
				/* @__PURE__ */ r("h4", {
					className: o.subtitle,
					children: "Log in or create a free account to score complete access to the best picks and intelligence in the industry"
				}),
				/* @__PURE__ */ r("div", {
					className: o.bulletsWrapper,
					"data-testid": "bullets-wrapper",
					children: [
						{
							title: "Expert Picks and Daily Best Bets",
							body: "Exclusive picks from the industry's most profitable handicappers. Our best-in-class experts have you covered with picks on the NFL, NCAAF, MLB, NBA and more"
						},
						{
							title: "Positive Value Bets",
							body: "Game and Player prediction AI models for every matchup"
						},
						{
							title: "Public Betting Splits",
							body: "Real-time market data on where the public and sharp action is betting"
						}
					].map((t, n) => /* @__PURE__ */ i("div", {
						className: o.benefitBullet,
						"data-testid": "benefit-bullet",
						children: [/* @__PURE__ */ r("span", {
							className: o.itemIcon,
							"data-testid": "icon",
							children: /* @__PURE__ */ r(e, {})
						}), /* @__PURE__ */ i("div", {
							className: o.itemTextWrapper,
							children: [/* @__PURE__ */ r("div", {
								className: o.itemHeader,
								"data-testid": "info-header",
								children: t?.title
							}), /* @__PURE__ */ r("div", {
								className: o.itemBody,
								"data-testid": "info-body",
								children: t?.body
							})]
						})]
					}, n))
				}),
				/* @__PURE__ */ i("div", {
					className: o.ctaWrapper,
					children: [/* @__PURE__ */ r("button", {
						className: o.primaryCta,
						onClick: () => {
							a("wall_sign_up", {}), n();
						},
						type: "button",
						children: "Create account"
					}), /* @__PURE__ */ r("button", {
						className: o.secondaryCta,
						"data-testid": "cancel",
						onClick: () => {
							a("wall_login", {}), t();
						},
						type: "button",
						children: "log in"
					})]
				})
			]
		})]
	});
}, c = (e) => {
	e.stopPropagation();
	let t = e.target;
	if (e.currentTarget.contains(t) && t.tagName === "A" && t.classList.contains("button-link") && t.target === "_blank") {
		let e = t.href;
		a("claimOffer", {
			eventCategory: "Offers",
			eventAction: "new_customers_offer",
			eventLabel: "hypertext_link",
			offer: {
				name: "",
				customer: "",
				bookie: "",
				type: "",
				clickoutURL: e
			}
		});
	}
}, l = {
	inlineHtmlWrapper: "_inlineHtmlWrapper_ygxdo_1",
	"no-borders": "_no-borders_ygxdo_242",
	"no-headers": "_no-headers_ygxdo_253"
}, u = ({ componentTags: e, containerRef: n, isLoggedIn: r }) => (t(() => {
	let e = (e) => {
		if (!n.current) return;
		let t = document.querySelector("[data-widget-provider=\"q4-widget\"]");
		t && t.src.startsWith(e.origin) && requestAnimationFrame(() => {
			t.style.height = `${e.data}px`;
		});
	};
	return window.addEventListener("message", e, !1), () => window.removeEventListener("message", e, !1);
}, []), { shouldRenderLoginWall: !r && e?.includes("TIPS_PREMIUM") }), d = ({ componentTags: e, html: t, isLoggedIn: i, onLogin: a, onSignup: o, resourcesUrl: d }) => {
	let f = n(null), { shouldRenderLoginWall: p } = u({
		componentTags: e,
		containerRef: f,
		isLoggedIn: i
	});
	return p ? /* @__PURE__ */ r(s, {
		onLogin: a,
		onSignup: o,
		resourcesUrl: d
	}) : /* @__PURE__ */ r("div", {
		className: l.inlineHtmlWrapper,
		dangerouslySetInnerHTML: { __html: t },
		"data-testid": "inline-html-div",
		onClick: c,
		ref: f
	});
}, f = d;
//#endregion
export { s as ArticleLoginWall, d as InlineHtml, f as default };
